import React, { useEffect, useState } from 'react';
import { Package } from 'lucide-react';
import { getBackendFileUrl } from '../../services/api';

// Картинка запчасти с заглушкой, если файла нет или он не загрузился
export default function PartImage({ src, alt = '', className = '', eager = false }) {
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        setFailed(false);
    }, [src]);

    if (!src || failed) {
        return (
            <div className={`part-image part-image--empty ${className}`} role="img" aria-label={alt || 'Нет фото'}>
                <Package size={34} strokeWidth={1.4} />
            </div>
        );
    }

    return (
        <img
            className={`part-image ${className}`}
            src={getBackendFileUrl(src)}
            alt={alt}
            loading={eager ? 'eager' : 'lazy'}
            decoding="async"
            onError={() => setFailed(true)}
        />
    );
}